import React from 'react';
import { TIUV_SHEMOT_CATEGORY_LABELS } from '../constants';

const CategoryField = React.memo(({ record, source }) => {
  const value = record[source];
  return <span>{TIUV_SHEMOT_CATEGORY_LABELS[value] || value}</span>;
});

export default CategoryField;
